@import '../../shared';

.form-code-input {
  input {
    @include form-component;

    height: 4.8rem;
    width: 4.5rem !important;
    font-size: $font-size-h1;
    border-radius: $border-radius-small;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 1.5rem;
    margin-right: 0.1rem !important;
    color: $blue-text;
    text-align: center;

    &:focus {
      outline: none;
      border-color: $blue;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &--accept input {
    border-color: $green-border;
    color: $green-text;
    &:focus {
      border-color: $green-border;
    }
  }

  &--reject input {
    border-color: $red-border;
    color: $red-text;
    &:focus {
      border-color: $red-border;
    }
  }
}
